import React from "react";
import Lobbies from "../components/Lobbies";

// The Home component now only renders the Lobbies part.
// The user state needed by Lobbies must be handled differently (see comment in MainLayout).
const Home: React.FC = () => {
  return (
    <div className="px-4 py-6 sm:px-0 space-y-6">
      {/* Lobbies Section - Always shown */}
      <div className="bg-white shadow rounded-lg p-6">
        <h3 className="text-lg font-medium mb-4">Available Game Lobbies</h3>
        {/* Lobbies now gets user state from context */}
        <Lobbies />
      </div>
    </div>
  );
};

export default Home;
